import http from "@/shared/api/http";

export async function getRoomsByCartId(cartId) {
  return unwrap(await http.get(`room/byCartId/${cartId}`)) ?? [];
}

export async function getAllRooms() {
  return unwrap(await http.get("room/all")) ?? [];
}

export async function createRoom(payload) {
  return unwrap(await http.post("room", payload));
}

export async function updateRoom(payload) {
  return unwrap(await http.put("room", payload));
}

export async function deleteRoom(id) {
  return unwrap(await http.delete(`room/${id}`));
}

function unwrap(res) {
  if (!res || !res.data) return null;

  if (res.data.value !== undefined) return res.data.value;

  return res.data;
}